// Carries the locally-selected video File + blob URL from Landing into the Editor so the
// user can preview/edit instantly while the real upload runs in the background.
// Kept in a module-level Map (not React state) so it survives route navigation.
const store = new Map();

export const localFirstEnabled = process.env.REACT_APP_LOCAL_FIRST_INGESTION === "true";

export function setLocalAsset(projectId, data) {
  store.set(projectId, data);
}
export function getLocalAsset(projectId) {
  return store.get(projectId) || null;
}
export function clearLocalAsset(projectId) {
  const a = store.get(projectId);
  if (a?.url) {
    try { URL.revokeObjectURL(a.url); } catch { /* noop */ }
  }
  store.delete(projectId);
}

// Read duration/width/height locally via a hidden <video> — no server round-trip.
export function readVideoMeta(file) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const v = document.createElement("video");
    v.preload = "metadata";
    v.muted = true;
    let done = false;
    const finish = (meta) => { if (done) return; done = true; resolve({ url, ...meta }); };
    v.onloadedmetadata = () => finish({ duration: v.duration || 0, width: v.videoWidth || 0, height: v.videoHeight || 0 });
    v.onerror = () => finish({ duration: 0, width: 0, height: 0 });
    setTimeout(() => finish({ duration: v.duration || 0, width: v.videoWidth || 0, height: v.videoHeight || 0 }), 4000);
    v.src = url;
  });
}
